﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";


const vatCheckboxSelectors = "#vat_checkbox,#vat_checkbox_mobile";


export function initiateVatToggle(){
    if ($(vatCheckboxSelectors).length) {
        $(vatCheckboxSelectors).each(function(){
           let self=$(this);
            //Add event listener to VAT checkbox
            $(self).change(function () {
                let vatCheckbox = $(self);
                if (vatCheckbox.is(':checked')) {
                    localStorage.setItem("vc_vatChecked", "true");
                    applyVatPrices($("body"), true);
                } else {
                    localStorage.setItem("vc_vatChecked", "false");
                    applyVatPrices($("body"), false);
                }
            });
        });
        

        //Check on page load for last checked state
        let currentVatChecked = localStorage.getItem("vc_vatChecked");
        if (currentVatChecked === "true") {
            $(vatCheckboxSelectors).each(function(){
                $(this).prop("checked", true);
            });
            applyVatPrices($("body"), true);
        }
        //Note: No need for include VAT price on page load because it is already set to the correct price
    }
}

//Apply VAT prices on UI
export function applyVatPrices(selector, vatStatus = null) {
    if (vatStatus === null) {
        let currentVatChecked = localStorage.getItem("vc_vatChecked");
        vatStatus = currentVatChecked === "true";
    }

    let pricesElements = $(selector).find('[data-vat-price]');
    let labelElements = $(selector).find('[data-vat-label]');

    labelElements.each(function (index, element) {
        let label = $(element);
        label.text(vatStatus ? "Inc VAT" : "Ex VAT");
    });

    pricesElements.each(function (index, element) {
        let price = $(element);
        if (vatStatus) {
            price.html(price.data('vat-inc'));
        } else {
            price.html(price.data('vat-ex'));
        }
    });
}

